import { splitButtonDefaultStyle, meatBallSplitButtonDefaultStyle } from './splitButtonDefaultStyle';
export const splitButtonStyleBuilder = (theme, buttonStyle, disabled) => {
  const style = splitButtonDefaultStyle(theme, buttonStyle, disabled);
  return style;
};
export const meatBallSplitButtonStyleBuilder = (theme, buttonStyle, disabled) => {
  const style = meatBallSplitButtonDefaultStyle(theme, buttonStyle, disabled);
  return style;
};